<template>

    <Combobox as="div" v-model="selected_choice">

        <div class="relative mt-1">

            <ComboboxInput class="w-full rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 shadow-sm
                                  focus:border-indigo-500 focus:outline-none focus:ring-1
                                  focus:ring-indigo-500 sm:text-sm flex items-center"
                @change="query = $event.target.value"
                as="div">

                <span class="inline-block h-4 w-4 flex-shrink-0 rounded-full mr-3"
                      :style="`background-color: ${ selected_choice.hex_name }`"
                      aria-hidden="true">
                </span>

                <span>{{ selected_choice.name }}</span>

            </ComboboxInput>


            <ComboboxButton class="absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none ">

                <SelectorIcon class="h-5 w-5 text-gray-400" aria-hidden="true" />

            </ComboboxButton>


            <ComboboxOptions class="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md
                                    bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5
                                    focus:outline-none sm:text-sm"
                 v-if="colors.length > 0">

                <ComboboxOption v-for="color in colors" :key="color.id" :value="color" as="template" v-slot="{ active, selected }">

                    <li :class="['relative cursor-default select-none py-2 pl-3 pr-9', active ? 'bg-indigo-600 text-white' : 'text-gray-900']">

                        <div class="flex items-center">

                            <span :class="`inline-block h-4 w-4 flex-shrink-0 rounded-full`"
                                  :style="`background-color: ${color.hex_name};`"
                                  aria-hidden="true" />


                            <span :class="['ml-3 truncate', selected && 'font-semibold']">

                                {{ color.name }}

                                <span class="text-gray-300 ml-2 text-sm">

                                    ({{ color.hex_name }})

                                </span>

                            </span>

                        </div>


                        <span v-if="selected" :class="['absolute inset-y-0 right-0 flex items-center pr-4', active ? 'text-white' : 'text-indigo-600']">

                            <CheckIcon class="h-5 w-5" aria-hidden="true" />

                        </span>


                    </li>

                </ComboboxOption>

            </ComboboxOptions>

        </div>

    </Combobox>

</template>

<script>
import { computed, ref } from 'vue'
import { CheckIcon, SelectorIcon } from '@heroicons/vue/solid'
import {
    Combobox,
    ComboboxButton,
    ComboboxInput,
    ComboboxLabel,
    ComboboxOption,
    ComboboxOptions,
} from '@headlessui/vue'

export default {
    components: {
        CheckIcon,
        Combobox,
        ComboboxButton,
        ComboboxInput,
        ComboboxLabel,
        ComboboxOption,
        ComboboxOptions,
        SelectorIcon,
    },

    setup(props) {

        const query = ref('');

        return {
            query,
        }
    },

    computed: {

        selected_choice: {
            get: function() {

                if ( ! this.colors ) {

                    return '';

                }

                let choice = this.colors[0];

                const chosen_key = _.findKey(this.colors, {
                    hex_name: this.selected_color
                });

                if ( chosen_key ) {

                    choice = this.colors[chosen_key];

                }

                return choice;

            },
            set: function(color) {

                this.$emit('change',color.hex_name);

            }
        }

    },


    props: {
        colors: {
            type: Array,
            default: () => {
                return [
                    {
                        id: 1,
                        name: 'Mørk blå',
                        hex_name: '#385988',
                        online: false,
                    }
                ];
            }
        },
        selected_color: String,
    }
}
</script>
